import React, { useEffect, useState } from "react";
import styles from "./ReportedBugs.module.sass";
import cn from "classnames";
import Card from "components/Card";
import { adminEndpoints, supportEndpoints } from "api/endpoints";
import devscntrAuth from "api/Instance/devscntrAuth";
import Item from "./Item";
import uuid from "react-uuid";
import Filter from "./Filter";
import { useLocation } from "react-router";
import axios from "axios";

const ReportedBugs = () => {
  // UTILS---------------------------------------------------------------------UTILS

  const [isMounted, setIsMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const searchUrl = useLocation().search;
  const [urlQuery, setUrlQuery] = useState("");

  const [refresh, setRefresh] = useState(false);
  const [reportedBugs, setReportedBugs] = useState([]);

  // UTILS---------------------------------------------------------------------UTILS
  // GET REPORTS---------------------------------------------------------GET REPORTS

  const getReports = async (cancelToken) => {
    try {
      const response = await devscntrAuth.request({
        method: "get",
        url: `${supportEndpoints.reportBug.show}${urlQuery}`,
        cancelToken: cancelToken.token,
      });
      console.log(response.data);
      setReportedBugs(response.data);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("admin reported bugs canceled");
      } else {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    const cancelToken = axios.CancelToken.source();
    if (urlQuery.length > 0) getReports(cancelToken);

    return () => {
      cancelToken.cancel();
    };
  }, [refresh, urlQuery]);

  useEffect(() => {
    setUrlQuery(searchUrl);
  }, [searchUrl]);

  // GET REPORTS---------------------------------------------------------GET REPORTS
  return (
    <Card
      className={styles.card}
      classCardHead={styles.head}
      title="Zgłoszone błędy"
      classTitle={cn("title-yellow", styles.title)}
      head={<Filter />}
    >
      <div className={styles.container}>
        <div className={styles.content}>
          {reportedBugs?.map((item) => (
            <Item key={uuid()} article={item} refresh={() => setRefresh((prev) => !prev)} />
          ))}
        </div>
      </div>
    </Card>
  );
};
export default ReportedBugs;
